import PropTypes from 'prop-types';

import { formatCents } from '#lib/numberFormat';

export const PlanPrice = ({ amountCents, isHighlighted = false, className = '' }) => {
	if (amountCents === null || amountCents === undefined) {
		return <p className={`text-lg-bold text-text ${className}`.trim()}>Preis auf Anfrage</p>;
	}

	return (
		<p className={`flex flex-wrap items-baseline gap-x-1.5 ${className}`.trim()}>
			<span className={`text-lg-bold ${isHighlighted ? 'text-primary-600' : 'text-text'}`}>
				{formatCents(amountCents)}
			</span>
			<span className="text-xs text-bgBase-800">/ Monat (netto)</span>
		</p>
	);
};

PlanPrice.propTypes = {
	amountCents: PropTypes.number,
	isHighlighted: PropTypes.bool,
	className: PropTypes.string,
};
